const gotoStripeDashboard = async () => {
  window.open("http://dashboard.stripe.com", "_blank");
};

export default gotoStripeDashboard;
